import styled from "styled-components";

export const Container = styled.div`
    position: relative;
`;

export const Button = styled.button<{ isPrimary: boolean }>`
    display: flex;
    align-items: center;
    padding: 8px;
    
    border-radius: 4px;
    gap: 8px;
    background-color: ${(props) => props.isPrimary ? props.theme.colors.primary : props.theme.colors.gray.gray_50};
    color: ${(props) => props.isPrimary && props.theme.colors.white};
    
    &:hover{
        background-color: ${(props) => props.isPrimary ? props.theme.colors.red.red_800 : props.theme.colors.gray.gray_100};
    }
`;

export const H6 = styled.p`
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray.gray_500};
`;


export const FilterModal = styled.div`
    position: absolute;
    z-index: 1;

    display: flex;
    flex-direction: column;
    gap: 8px;

    margin-top: 5px;
    border-radius: 4px;
    padding: 10px;
    
    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    `;

export const ContentFilter = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    max-height: 160px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
        width: 5px;
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    &::-webkit-scrollbar-thumb{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        border-radius: 20px;
    }
`;

export const Label = styled.label`
    font-size: 12px;
    color: ${(props) => props.theme.colors.gray.gray_200};
    `;

export const ButtonFilter = styled.button`
    display: flex;
    align-items: center;
    gap: 4px;
    background-color: ${(props) => props.theme.colors.white};
    padding: 4px;
    border-radius: 4px;
    
    &.active{
        background-color: ${(props) => props.theme.colors.red.red_50};
        color: ${(props) => props.theme.colors.primary};
    }
    
    &:hover{
        background-color: ${(props) => props.theme.colors.red.red_50};
    }
`;

export const Footer = styled.footer`
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding-top: 8px;
    border-top: 1px dashed ${(props) => props.theme.colors.gray.gray_100};
`;